module.exports = __webpack_public_path__ + "img/1893_uk.9d0bbdb9.svg";